

const state = () => ({
    selectedItems: []
})

const mutations = {
    addRoute (state, item) {
        state.selectedItems.push(item)
    },
    removeRoute (state, item) {
        state.selectedItems = state.selectedItems.filter(i => i.id !== item.id)
    }
}

const getters = {
    isSelected: (state) => (itemId) => {
        return state.selectedItems.findIndex(item => item.id === itemId) > -1
    },
}

export default {namespaced: true, state, mutations, getters}